






















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class PercentageCircleIcon extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: '#405F7A' }) readonly fill?: string;
}
